<template>
  <div class="page">
    <!-- panels start -->
    <div class="uploadPanels">
      <!-- 全部  -->

      <!-- digColl start -->
      <div class="digColl uploadColl">
        <div class="digList">
          <div v-for="(s, idx) in list" :key="idx" class="itm" :data-index="idx">
            <h4 class="t" @click="toDetail(s.id)">{{ s.collectionName }}</h4>
            <p class="desc" @click="toDetail(s.id)">{{ s.description }}</p>
            <div class="entLabel">
              <span v-if="s.pictureNumber > 0||s.audioNumber > 0||s.videoNumber > 0||s.otherNumber > 0" class="spanList"><em v-if="s.pictureNumber > 0">{{ s.pictureNumber }}图片</em><em v-if="s.videoNumber > 0">{{ s.videoNumber }}视频</em><em v-if="s.audioNumber > 0">{{ s.audioNumber }}音频</em><em v-if="s.otherNumber > 0">{{ s.otherNumber }}文件</em></span>
              <a href="javascript:;" class="btn-del" :data-index="idx" @click="showdelapply">取消收藏</a>
            </div>
            <div
              class="img"
              :style="{
                background: 'url(' + s.preview + ')',
                'background-position': 'center',
                'background-size': 'cover',
              }"
              @click="toDetail(s)"
            />
          </div>
        </div>
        <div v-if="isMore" style="height: 50px; width: 100%; color: #333; line-height: 50px; font-size: 12px;text-align: center;" @click="loadMore">
          点击加载更多
        </div>
        <div v-else style="height: 50px; width: 100%; color: #333; line-height: 50px; font-size: 12px;text-align: center;">
          没有更多了
        </div>
      </div>
    <!-- digColl end -->
    </div>
    <!-- panels end -->

    <!-- 导航 start -->
    <div class="naviPosition" />
    <div class="digNavigate">
      <router-link class="navItm" :to="{ name: 'Waphome' }">
        <img src="../../../../images/home.png" class="img-normal">
        <img src="../../../../images/home_select.png" class="img-active">
        <label>首页</label>
      </router-link>
      <router-link class="navItm" :to="{ name: 'Waplist' }">
        <img src="../../../../images/res.png" class="img-normal">
        <img src="../../../../images/res_select.png" class="img-active">
        <label>特藏</label>
      </router-link>
      <router-link class="navItm" :to="{ name: 'Wapupload' }">
        <img src="../../../../images/upload.jpg" class="img-normal">
        <img src="../../../../images/upload_select.jpg" class="img-active">
        <label>上传</label>
      </router-link>
      <router-link class="navItm active" :to="{ name: 'Wapuser' }">
        <img src="../../../../images/use.png" class="img-normal">
        <img src="../../../../images/use_select.png" class="img-active">
        <label>我的</label>
      </router-link>
    </div>
  <!-- 导航 end -->
  </div>
</template>

<script>
import api from '../../../../api/userpage.js'
import user from '../../../../models/user.js'

export default {
  name: 'Wapusercollection',
  data() {
    return {
      list: [],
      pageIndex: 1,
      pageSize: 25,
      totalCount: 0

    }
  },
  computed: {
    isMore() {
      return this.list.length < this.totalCount
    }
  },
  created() {
    this.request()
  },
  mounted() {
    window.addEventListener('scroll', this.handlerScrooll, true)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handlerScrooll)
  },
  methods: {
    loadMore() {
      this.pageIndex = this.pageIndex + 1
      this.request()
    },
    request() {
      const that = this
      api.personcollections({
        current: this.pageIndex,
        size: this.pageSize
      }).then(r => {
        const {
          data
        } = r
        if (this.pageIndex === 1) {
          that.list = data.records
        } else {
          that.list = that.list.concat(data.records)
        }
        that.totalCount = data.total
      }).catch(error => {
        console.log(error)
      })
    },
    showdelapply(e) {
      const idx = e.currentTarget.dataset.index
      const params = {
        collectionId: this.list[idx].collectionId,
        userId: 'CQUP002'
      }
      api.removecollection(params).then(r => {
        console.log(r)
        console.log('移除收藏成功')
        alert('移除收藏成功')
        this.pageIndex = 1
        this.request()
      }).catch(err => {
        console.log(err)
      })
    },
    toDetail(v) {
      this.$router.push({
        name: 'Wapdetail',
        query: {
          rsId: v.id,
          permission: v.permissionRange
        }
      })
    }
  }
}
</script>

<style src="@/styles/wap.scss" lang="scss" scoped>

</style>
<style scoped>
  .spanList em{
      margin-right: 5px;
  }
  .spanList em :last-child{
    margin-right: 0px;
  }
</style>
